import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';

import { sidebarMenuListItemHighlight } from 'styles/sidebarMenuListItemHighlight';
import { hexToRgbA } from 'utils/colors';

export const VIEWPORT_MARGIN = 10;

const menuTriggerSurface = css<{ $expanded?: boolean }>`
  background: ${({ theme, $expanded }) =>
    $expanded ? hexToRgbA(theme.color.pickledBluewood, 0.12) : 'transparent'};

  &:hover {
    background: ${({ theme }) => hexToRgbA(theme.color.pickledBluewood, 0.12)};
  }
`;

export const StyledMenuRoot = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const StyledMenuTrigger = styled.button<{ $expanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  border: none;
  cursor: pointer;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  transition: background 0.2s ease, transform 0.2s ease;
  ${menuTriggerSurface}

  &:active {
    transform: scale(0.96);
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.color.brightTurquoise};
  }
`;

export const StyledPanelAnchor = styled.div`
  position: fixed;
  z-index: 100000001;
`;

export const StyledPanel = styled.div`
  min-width: 208px;
  max-width: 260px;
  max-height: calc(100svh - ${VIEWPORT_MARGIN * 2}px);
  padding: 10px 0 12px;
  background: ${({ theme }) => theme.color.white};
  border-radius: 10px;
  box-shadow: 0 6px 20px
    ${({ theme }) => hexToRgbA(theme.color.pickledBluewood, 0.14)};
  overflow-x: hidden;
  overflow-y: auto;
`;

export const StyledPanelTitle = styled.div`
  padding: 4px 16px 10px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  color: ${({ theme }) => theme.color.baliHai};
`;

export const StyledPanelDivider = styled.div`
  height: 1px;
  margin: 0 16px 8px;
  background-color: ${({ theme }) => theme.color.porcelain};
`;

export const StyledMenuList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0 4px;
`;

export const StyledMenuEmoji = styled.span`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 20px;
  font-size: 16px;
  line-height: 1;
`;

export const StyledMenuLabel = styled.span`
  flex: 1;
  min-width: 0;
  font-weight: 400;
`;

const menuItemLinkStyles = css`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  margin: 0 4px;
  font-size: 13px;
  line-height: 1.25;
  color: ${({ theme }) => theme.color.pickledBluewood};
  text-decoration: none;
  border-radius: 6px;
  ${sidebarMenuListItemHighlight({
    indicatorLeft: '4px',
    includeActive: false,
  })}

  &:focus-visible {
    outline: none;
  }
`;

export const StyledMenuLink = styled.a`
  ${menuItemLinkStyles}
`;

export const StyledMenuNavLink = styled(NavLink)`
  ${menuItemLinkStyles}
`;
